import styled, { css } from "styled-components";


type ButtonBarVariant = 'left-aligned' | 'right-aligned' | 'centered' | 'stretched' | 'space-between';
export const ButtonRow = styled.div<{ variant?:ButtonBarVariant, marginTop?:number, marginBottom?:number, marginLeft?:number, marginRight?:number }>`
    display: flex;
    flex-direction: row;
    justify-content:${(props) => {
        switch(props.variant){
            case 'left-aligned': return 'flex-start';
            case 'centered': return 'center';
            case 'right-aligned': return 'flex-end';
            case 'space-between': return 'space-between';
            default: return 'flex-end';
        }
    }};
    ${props => props.variant === 'stretched' 
        ? css`
            & > * {
                flex:1;
            }`
        : ''
    }
    gap: 10px;
    
    ${props => {
        if(props.marginTop!==undefined)
            return css`
                margin-top:${props.marginTop}px;
            `;
    }};
    ${props => {
        if(props.marginRight!==undefined)
            return css`
                margin-right:${props.marginRight}px;
            `;
    }};
    ${props => {
        if(props.marginBottom!==undefined)
            return css`
                margin-bottom:${props.marginBottom}px;
            `;
    }};
    ${props => {
        if(props.marginLeft!==undefined)
            return css`
                margin-left:${props.marginLeft}px;
            `;
    }};
`;

export const BorderRow = styled.div`
    border: 1px dotted black;
    padding: 10px;
`

export const Row = styled.div`
    gap:20px;
    display: flex;
    flex-direction: row;
    align-items: top;

    & > * {
        flex: 1 1 0px;
    }
`;